import {testIdProps} from '@github-ui/test-id-props'
import {Token, type TokenProps} from '@primer/react'
import {clsx} from 'clsx'
import {forwardRef} from 'react'

import type {ParentIssue} from '../../api/common-contracts'
import {ItemType} from '../../api/memex-items/item-type'
import {useOpenParentIssue} from '../../features/sub-issues/use-open-parent-issue'
import {tokenIconSize} from '../common/avatars-token'
import {SanitizedHtml} from '../dom/sanitized-html'
import {ItemState} from '../item-state'
import styles from './parent-issue-token.module.css'

export interface ParentIssueTokenProps extends Omit<TokenProps, 'href' | 'leadingVisual' | 'text' | 'ref' | 'sx'> {
  parentIssue: ParentIssue | undefined
}

export const ParentIssueToken = forwardRef<HTMLElement, ParentIssueTokenProps>(
  ({parentIssue, className, as = 'a', ...tokenProps}, ref) => {
    const {openParentIssue} = useOpenParentIssue()

    if (!parentIssue) return null

    const titleHtml = parentIssue.titleHtml

    return (
      <div className={styles.ParentIssueTokenContainer}>
        <Token
          onClick={() => openParentIssue(parentIssue)}
          ref={ref}
          as={as}
          target="_blank"
          rel="noreferrer"
          data-hovercard-url={`${parentIssue.url}/hovercard`}
          data-hovercard-type="issue"
          leadingVisual={() => (
            <ItemState
              isDraft={false}
              isBlocked={false}
              state={parentIssue.state}
              stateReason={parentIssue.stateReason}
              type={ItemType.Issue}
              size={tokenIconSize(tokenProps.size)}
            />
          )}
          className={clsx(styles.ParentIssueTokenMain, className)}
          text={<SanitizedHtml>{`${titleHtml} #${parentIssue.number}`}</SanitizedHtml>}
          {...testIdProps(`parent-issue-token`)}
          {...tokenProps}
        />
      </div>
    )
  },
)
ParentIssueToken.displayName = 'ParentIssueToken'
